import {Search} from '@ultradent/components';
import DistributorLine from '@components/distributors/DistributorLine';
import {DISTRIBUTORS_LIST_TITLE, SEARCH_PLACEHOLDER, SEARCH_SUBTITLE} from '@components/distributors/i18n';

const DistributorListSearch = ( props ) =>
    <div className="mb-1 pb-2">
        <p className="subheading-base mb-4">{SEARCH_SUBTITLE}</p>
        <Search
            hideOnFocusout={false}
            queryGroup={[
                {
                    list: props.list,
                    filter: i => i.type === 'Salesrep',
                    queryProps: ['title', 'address'],
                    renderer: DistributorLine,
                    resultLimit: 11
                },
                {
                    list: props.list,
                    filter: i => i.type === 'Distributor',
                    queryProps: ['title', 'address'],
                    renderer: DistributorLine,
                    resultLimit: 64
                }
            ]}>
            {searchProps =>
                <div data-testid="distributor-search-results">
                    <div className="flex w-full">
                        <Search.Input className="w-full"
                                      inputAppendClassName="absolute pin-l"
                                      placeholder={SEARCH_PLACEHOLDER}/>
                    </div>
                    <Search.Results>
                        {results => <div className="my-2" data-testid="filterlist-results">{results}</div>}
                    </Search.Results>
                    {searchProps.hasResults &&
                        <h3 className="headline-xs mt-8 md:mt-12 mb-0">{DISTRIBUTORS_LIST_TITLE}</h3>
                    }
                </div>
            }
        </Search>
    </div>;

export default DistributorListSearch;